import {
  LIST_DISCURSIVE_ASSESSMENTS_REQUEST,
  LIST_DISCURSIVE_ASSESSMENTS_SUCCESS,
  LIST_DISCURSIVE_ASSESSMENTS_ERROR,
  GET_DISCURSIVE_ASSESSMENT_REQUEST,
  GET_DISCURSIVE_ASSESSMENT_SUCCESS,
  GET_DISCURSIVE_ASSESSMENT_ERROR,
  ADD_DISCURSIVE_ASSESSMENT_REQUEST,
  ADD_DISCURSIVE_ASSESSMENT_SUCCESS,
  ADD_DISCURSIVE_ASSESSMENT_ERROR,
  EDIT_DISCURSIVE_ASSESSMENT_REQUEST,
  EDIT_DISCURSIVE_ASSESSMENT_SUCCESS,
  EDIT_DISCURSIVE_ASSESSMENT_ERROR,
  EDIT_ACTIVE_DISCURSIVE_ASSESSMENT_REQUEST,
  EDIT_ACTIVE_DISCURSIVE_ASSESSMENT_SUCCESS,
  EDIT_ACTIVE_DISCURSIVE_ASSESSMENT_ERROR,
  LIST_DISCURSIVE_ASSESSMENT_SUBJECTS_REQUEST,
  LIST_DISCURSIVE_ASSESSMENT_SUBJECTS_SUCCESS,
  LIST_DISCURSIVE_ASSESSMENT_SUBJECTS_ERROR,
  LIST_DISCURSIVE_QUESTION_FIELDS_REQUEST,
  LIST_DISCURSIVE_QUESTION_FIELDS_SUCCESS,
  LIST_DISCURSIVE_QUESTION_FIELDS_ERROR,
  VINCULATE_DISCURSIVE_ASSESSMENT_SUBJECTS_REQUEST,
  VINCULATE_DISCURSIVE_ASSESSMENT_SUBJECTS_SUCCESS,
  VINCULATE_DISCURSIVE_ASSESSMENT_SUBJECTS_ERROR,
  VINCULATE_DISCURSIVE_ASSESSMENT_QUESTIONS_REQUEST,
  VINCULATE_DISCURSIVE_ASSESSMENT_QUESTIONS_SUCCESS,
  VINCULATE_DISCURSIVE_ASSESSMENT_QUESTIONS_ERROR,
  SEND_DISCURSIVE_ASSESSMENT_REQUEST,
  SEND_DISCURSIVE_ASSESSMENT_SUCCESS,
  SEND_DISCURSIVE_ASSESSMENT_ERROR,
  RESET_STATE_REDUX,
  RESET_STATE_ALL_APPLICATION,
} from '../actions';

const INIT_STATE = {
  currentDiscursiveAssessment: null,
  currentDiscursiveAssessmentsList: null,
  tempDiscursiveAssessmentSubjectIds: null,
  subjects: null,
  questionFields: null,
  loading: false,
  error: '',
  success: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_STATE_ALL_APPLICATION:
      return INIT_STATE;
    case RESET_STATE_REDUX:
      return {
        ...state,
        error: '',
        success: '',
        currentDiscursiveAssessment: null,
        tempDiscursiveAssessmentSubjectIds: null,
      };
    case GET_DISCURSIVE_ASSESSMENT_REQUEST:
    case LIST_DISCURSIVE_ASSESSMENTS_REQUEST:
    case ADD_DISCURSIVE_ASSESSMENT_REQUEST:
    case EDIT_DISCURSIVE_ASSESSMENT_REQUEST:
    case LIST_DISCURSIVE_ASSESSMENT_SUBJECTS_REQUEST:
    case LIST_DISCURSIVE_QUESTION_FIELDS_REQUEST:
    case VINCULATE_DISCURSIVE_ASSESSMENT_SUBJECTS_REQUEST:
    case VINCULATE_DISCURSIVE_ASSESSMENT_QUESTIONS_REQUEST:
      return { ...state, loading: true, error: '', success: '' };

    case GET_DISCURSIVE_ASSESSMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        currentDiscursiveAssessment: action.payload,
      };
    case LIST_DISCURSIVE_ASSESSMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        currentDiscursiveAssessmentsList: action.payload,
      };
    case ADD_DISCURSIVE_ASSESSMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };
    case EDIT_DISCURSIVE_ASSESSMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };
    case EDIT_ACTIVE_DISCURSIVE_ASSESSMENT_REQUEST:
      return { ...state, loading: false, error: '', success: '' };
    case EDIT_ACTIVE_DISCURSIVE_ASSESSMENT_SUCCESS: {
      const updatedList = (state.currentDiscursiveAssessmentsList ?? []).map((item) => {
        if (item.id === action.payload.id) {
          return { ...item, active: action.payload.active };
        }
        return item;
      });
      return {
        ...state,
        currentDiscursiveAssessmentsList: updatedList,
        success: action.payload,
      };
    }
    case LIST_DISCURSIVE_ASSESSMENT_SUBJECTS_SUCCESS:
      return {
        ...state,
        loading: false,
        subjects: action.payload,
      };
    case LIST_DISCURSIVE_QUESTION_FIELDS_SUCCESS:
      return {
        ...state,
        loading: false,
        questionFields: action.payload,
      };
    case VINCULATE_DISCURSIVE_ASSESSMENT_SUBJECTS_SUCCESS:
      return {
        ...state,
        loading: false,
        tempDiscursiveAssessmentSubjectIds: action.payload.subjects,
      };
    case VINCULATE_DISCURSIVE_ASSESSMENT_QUESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload.isLastSubject,
      };
    case SEND_DISCURSIVE_ASSESSMENT_REQUEST:
      return { ...state, loading: false, error: '', success: '' };
    case SEND_DISCURSIVE_ASSESSMENT_SUCCESS: {
      const updatedList = (state.currentDiscursiveAssessmentsList ?? []).map((item) => {
        if (item.id === action.payload.id) {
          return { ...item, sent_at: action.payload.sentAt };
        }
        return item;
      });
      return {
        ...state,
        currentDiscursiveAssessmentsList: updatedList,
      };
    }
    case GET_DISCURSIVE_ASSESSMENT_ERROR:
    case LIST_DISCURSIVE_ASSESSMENTS_ERROR:
    case ADD_DISCURSIVE_ASSESSMENT_ERROR:
    case EDIT_DISCURSIVE_ASSESSMENT_ERROR:
    case EDIT_ACTIVE_DISCURSIVE_ASSESSMENT_ERROR:
    case LIST_DISCURSIVE_ASSESSMENT_SUBJECTS_ERROR:
    case LIST_DISCURSIVE_QUESTION_FIELDS_ERROR:
    case VINCULATE_DISCURSIVE_ASSESSMENT_SUBJECTS_ERROR:
    case VINCULATE_DISCURSIVE_ASSESSMENT_QUESTIONS_ERROR:
    case SEND_DISCURSIVE_ASSESSMENT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    default:
      return { ...state };
  }
};
